import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetAttendUsersQuery =
  operations['AdminGroupEventController_groupEventMemberList']['parameters']['query'];
type GetAttendUsersHeaders =
  operations['AdminGroupEventController_groupEventMemberList']['parameters']['header'];
type GetAttendUsersPath =
  operations['AdminGroupEventController_groupEventMemberList']['parameters']['path'];

interface GetAttendUsersProps {
  path: GetAttendUsersPath;
  query: GetAttendUsersQuery;
  headers?: OmitGroupIdInHeader<GetAttendUsersHeaders>;
}

type GetAttendEventsUsersResponse =
  components['schemas']['List$GroupEventMember$clz1TxwxdxN9ya9riei5ow'];

export async function getAttendUsers({
  path,
  query,
  headers,
}: GetAttendUsersProps): Promise<GetAttendEventsUsersResponse | false> {
  const response = await authenticateRequest<GetAttendEventsUsersResponse>({
    method: 'get',
    url: `/api/v1/admin/group-event/${path.groupEventId}/members`,
    headers,
    params: query,
  });

  console.log('getAttendUsers', { response });
  return response;
}

export type { GetAttendUsersQuery, GetAttendEventsUsersResponse };
